/* eslint-disable */

export interface ResolveEntityTypeRequest {
  uri: string[];
}

export interface ResolveEntityTypeResponse {
  resolvedEntityType: ResolvedEntityType[];
}

export interface ResolvedEntityType {
  uri: string;
  entityType: EntityType;
  entityExists: boolean;
}

export interface ResolveAssetTypeRequest {
  uri: string;
  associatedContentType: AssociatedContentType;
}

export interface ResolveAssetTypeResponse {
  assetExists: boolean;
}

export interface AssociatedContentRequest {
  uri: string;
  associatedContentType: AssociatedContentType;
}

export interface MultipleAssociatedContentRequest {
  uris: string[];
  associatedContentType: AssociatedContentType;
}

export interface MultipleAssociatedContentResponse {
  associatedContent: AssociatedContentResponse[];
}

export interface AssociatedContentResponse {
  parentEntityExists: boolean;
  elements: AssociatedContent[];
  entityType: EntityType;
  parentUri: string;
}

export interface AssociatedContent {
  id: string;
  value: string;
}

const baseResolveEntityTypeRequest: object = {
  uri: '',
};

const baseResolveEntityTypeResponse: object = {};

const baseResolvedEntityType: object = {
  uri: '',
  entityType: 0,
  entityExists: false,
};

const baseResolveAssetTypeRequest: object = {
  uri: '',
  associatedContentType: 0,
};

const baseResolveAssetTypeResponse: object = {
  assetExists: false,
};

const baseAssociatedContentRequest: object = {
  uri: '',
  associatedContentType: 0,
};

const baseMultipleAssociatedContentRequest: object = {
  uris: '',
  associatedContentType: 0,
};

const baseMultipleAssociatedContentResponse: object = {};

const baseAssociatedContentResponse: object = {
  parentEntityExists: false,
  entityType: 0,
  parentUri: '',
};

const baseAssociatedContent: object = {
  id: '',
  value: '',
};

export interface AssociatedContentService {
  GetAssociatedContent(request: AssociatedContentRequest): Promise<AssociatedContentResponse>;

  GetMultipleAssociatedContent(request: MultipleAssociatedContentRequest): Promise<MultipleAssociatedContentResponse>;
}

export interface ContentTypeResolverService {
  /**
   *  This service will always return a resolved Entity Type for supported URIs.
   *   If an Entity doesn't exist, it will default to the value derived from the URI.
   */
  ResolveEntityType(request: ResolveEntityTypeRequest): Promise<ResolveEntityTypeResponse>;

  ResolveAssetType(request: ResolveAssetTypeRequest): Promise<ResolveAssetTypeResponse>;
}

export const protobufPackage = 'spotify.inspectorgadget.v1';

export enum EntityType {
  ENTITY_TYPE_UNKNOWN = 0,
  ENTITY_TYPE_SHOW = 1,
  ENTITY_TYPE_EPISODE = 2,
  ENTITY_TYPE_ALBUM = 3,
  ENTITY_TYPE_TRACK = 4,
  ENTITY_TYPE_PLAYLIST = 5,
  ENTITY_TYPE_ARTIST = 6,
  ENTITY_TYPE_AUDIOBOOK = 9,
  ENTITY_TYPE_AUDIOBOOK_CHAPTER = 10,
  ENTITY_TYPE_USER = 11,
  ENTITY_TYPE_ARTIST_EXPRESSION = 12,
  ENTITY_TYPE_ALBUM_PRERELEASE_EXPRESSION = 13,
  ENTITY_TYPE_QUESTION = 14,
  ENTITY_TYPE_POLL = 15,
  ENTITY_TYPE_RESPONSE = 16,
  ENTITY_TYPE_COURSE = 17,
  ENTITY_TYPE_LESSON = 18,
  ENTITY_TYPE_MERCH = 19,
  ENTITY_TYPE_COMMENT = 20,
  ENTITY_TYPE_CHAT_MESSAGE = 21,
  ENTITY_TYPE_PODCAST_EXPRESSION = 22,
  ENTITY_TYPE_PODCAST_THUMBNAIL = 23,
  ENTITY_TYPE_SUPPLEMENTARY_MATERIAL = 24,
}

export function entityTypeFromJSON(object: any): EntityType {
  switch (object) {
    case 0:
    case 'ENTITY_TYPE_UNKNOWN':
      return EntityType.ENTITY_TYPE_UNKNOWN;
    case 1:
    case 'ENTITY_TYPE_SHOW':
      return EntityType.ENTITY_TYPE_SHOW;
    case 2:
    case 'ENTITY_TYPE_EPISODE':
      return EntityType.ENTITY_TYPE_EPISODE;
    case 3:
    case 'ENTITY_TYPE_ALBUM':
      return EntityType.ENTITY_TYPE_ALBUM;
    case 4:
    case 'ENTITY_TYPE_TRACK':
      return EntityType.ENTITY_TYPE_TRACK;
    case 5:
    case 'ENTITY_TYPE_PLAYLIST':
      return EntityType.ENTITY_TYPE_PLAYLIST;
    case 6:
    case 'ENTITY_TYPE_ARTIST':
      return EntityType.ENTITY_TYPE_ARTIST;
    case 9:
    case 'ENTITY_TYPE_AUDIOBOOK':
      return EntityType.ENTITY_TYPE_AUDIOBOOK;
    case 10:
    case 'ENTITY_TYPE_AUDIOBOOK_CHAPTER':
      return EntityType.ENTITY_TYPE_AUDIOBOOK_CHAPTER;
    case 11:
    case 'ENTITY_TYPE_USER':
      return EntityType.ENTITY_TYPE_USER;
    case 12:
    case 'ENTITY_TYPE_ARTIST_EXPRESSION':
      return EntityType.ENTITY_TYPE_ARTIST_EXPRESSION;
    case 13:
    case 'ENTITY_TYPE_ALBUM_PRERELEASE_EXPRESSION':
      return EntityType.ENTITY_TYPE_ALBUM_PRERELEASE_EXPRESSION;
    case 14:
    case 'ENTITY_TYPE_QUESTION':
      return EntityType.ENTITY_TYPE_QUESTION;
    case 15:
    case 'ENTITY_TYPE_POLL':
      return EntityType.ENTITY_TYPE_POLL;
    case 16:
    case 'ENTITY_TYPE_RESPONSE':
      return EntityType.ENTITY_TYPE_RESPONSE;
    case 17:
    case 'ENTITY_TYPE_COURSE':
      return EntityType.ENTITY_TYPE_COURSE;
    case 18:
    case 'ENTITY_TYPE_LESSON':
      return EntityType.ENTITY_TYPE_LESSON;
    case 19:
    case 'ENTITY_TYPE_MERCH':
      return EntityType.ENTITY_TYPE_MERCH;
    case 20:
    case 'ENTITY_TYPE_COMMENT':
      return EntityType.ENTITY_TYPE_COMMENT;
    case 21:
    case 'ENTITY_TYPE_CHAT_MESSAGE':
      return EntityType.ENTITY_TYPE_CHAT_MESSAGE;
    case 22:
    case 'ENTITY_TYPE_PODCAST_EXPRESSION':
      return EntityType.ENTITY_TYPE_PODCAST_EXPRESSION;
    case 23:
    case 'ENTITY_TYPE_PODCAST_THUMBNAIL':
      return EntityType.ENTITY_TYPE_PODCAST_THUMBNAIL;
    case 24:
    case 'ENTITY_TYPE_SUPPLEMENTARY_MATERIAL':
      return EntityType.ENTITY_TYPE_SUPPLEMENTARY_MATERIAL;
    default:
      throw new globalThis.Error('Unrecognized enum value ' + object + ' for enum EntityType');
  }
}

export function entityTypeToJSON(object: EntityType): string {
  switch (object) {
    case EntityType.ENTITY_TYPE_UNKNOWN:
      return 'ENTITY_TYPE_UNKNOWN';
    case EntityType.ENTITY_TYPE_SHOW:
      return 'ENTITY_TYPE_SHOW';
    case EntityType.ENTITY_TYPE_EPISODE:
      return 'ENTITY_TYPE_EPISODE';
    case EntityType.ENTITY_TYPE_ALBUM:
      return 'ENTITY_TYPE_ALBUM';
    case EntityType.ENTITY_TYPE_TRACK:
      return 'ENTITY_TYPE_TRACK';
    case EntityType.ENTITY_TYPE_PLAYLIST:
      return 'ENTITY_TYPE_PLAYLIST';
    case EntityType.ENTITY_TYPE_ARTIST:
      return 'ENTITY_TYPE_ARTIST';
    case EntityType.ENTITY_TYPE_AUDIOBOOK:
      return 'ENTITY_TYPE_AUDIOBOOK';
    case EntityType.ENTITY_TYPE_AUDIOBOOK_CHAPTER:
      return 'ENTITY_TYPE_AUDIOBOOK_CHAPTER';
    case EntityType.ENTITY_TYPE_USER:
      return 'ENTITY_TYPE_USER';
    case EntityType.ENTITY_TYPE_ARTIST_EXPRESSION:
      return 'ENTITY_TYPE_ARTIST_EXPRESSION';
    case EntityType.ENTITY_TYPE_ALBUM_PRERELEASE_EXPRESSION:
      return 'ENTITY_TYPE_ALBUM_PRERELEASE_EXPRESSION';
    case EntityType.ENTITY_TYPE_QUESTION:
      return 'ENTITY_TYPE_QUESTION';
    case EntityType.ENTITY_TYPE_POLL:
      return 'ENTITY_TYPE_POLL';
    case EntityType.ENTITY_TYPE_RESPONSE:
      return 'ENTITY_TYPE_RESPONSE';
    case EntityType.ENTITY_TYPE_COURSE:
      return 'ENTITY_TYPE_COURSE';
    case EntityType.ENTITY_TYPE_LESSON:
      return 'ENTITY_TYPE_LESSON';
    case EntityType.ENTITY_TYPE_MERCH:
      return 'ENTITY_TYPE_MERCH';
    case EntityType.ENTITY_TYPE_COMMENT:
      return 'ENTITY_TYPE_COMMENT';
    case EntityType.ENTITY_TYPE_CHAT_MESSAGE:
      return 'ENTITY_TYPE_CHAT_MESSAGE';
    case EntityType.ENTITY_TYPE_PODCAST_EXPRESSION:
      return 'ENTITY_TYPE_PODCAST_EXPRESSION';
    case EntityType.ENTITY_TYPE_PODCAST_THUMBNAIL:
      return 'ENTITY_TYPE_PODCAST_THUMBNAIL';
    case EntityType.ENTITY_TYPE_SUPPLEMENTARY_MATERIAL:
      return 'ENTITY_TYPE_SUPPLEMENTARY_MATERIAL';
    default:
      return 'UNKNOWN';
  }
}

export enum AssociatedContentType {
  ASSOCIATED_CONTENT_TYPE_INVALID = 0,
  ASSOCIATED_CONTENT_TYPE_ARTIST_BANNER_IMAGE = 1,
  ASSOCIATED_CONTENT_TYPE_ARTIST_PROFILE_IMAGE = 2,
  ASSOCIATED_CONTENT_TYPE_ARTIST_GALLERY_IMAGE = 3,
  ASSOCIATED_CONTENT_TYPE_PLAYLIST_IMAGE = 4,
  ASSOCIATED_CONTENT_TYPE_PLAYLIST_TITLE = 5,
  ASSOCIATED_CONTENT_TYPE_PLAYLIST_DESCRIPTION = 6,
  ASSOCIATED_CONTENT_TYPE_USER_IMAGE = 7,
  ASSOCIATED_CONTENT_TYPE_TRACK_CANVAS = 8,
  ASSOCIATED_CONTENT_TYPE_ARTIST_MERCH = 9,
  ASSOCIATED_CONTENT_TYPE_TRACK_MUSIC_VIDEO = 10,
  ASSOCIATED_CONTENT_TYPE_ALBUM_OR_PODCAST_ARTWORK = 11,
}

export function associatedContentTypeFromJSON(object: any): AssociatedContentType {
  switch (object) {
    case 0:
    case 'ASSOCIATED_CONTENT_TYPE_INVALID':
      return AssociatedContentType.ASSOCIATED_CONTENT_TYPE_INVALID;
    case 1:
    case 'ASSOCIATED_CONTENT_TYPE_ARTIST_BANNER_IMAGE':
      return AssociatedContentType.ASSOCIATED_CONTENT_TYPE_ARTIST_BANNER_IMAGE;
    case 2:
    case 'ASSOCIATED_CONTENT_TYPE_ARTIST_PROFILE_IMAGE':
      return AssociatedContentType.ASSOCIATED_CONTENT_TYPE_ARTIST_PROFILE_IMAGE;
    case 3:
    case 'ASSOCIATED_CONTENT_TYPE_ARTIST_GALLERY_IMAGE':
      return AssociatedContentType.ASSOCIATED_CONTENT_TYPE_ARTIST_GALLERY_IMAGE;
    case 4:
    case 'ASSOCIATED_CONTENT_TYPE_PLAYLIST_IMAGE':
      return AssociatedContentType.ASSOCIATED_CONTENT_TYPE_PLAYLIST_IMAGE;
    case 5:
    case 'ASSOCIATED_CONTENT_TYPE_PLAYLIST_TITLE':
      return AssociatedContentType.ASSOCIATED_CONTENT_TYPE_PLAYLIST_TITLE;
    case 6:
    case 'ASSOCIATED_CONTENT_TYPE_PLAYLIST_DESCRIPTION':
      return AssociatedContentType.ASSOCIATED_CONTENT_TYPE_PLAYLIST_DESCRIPTION;
    case 7:
    case 'ASSOCIATED_CONTENT_TYPE_USER_IMAGE':
      return AssociatedContentType.ASSOCIATED_CONTENT_TYPE_USER_IMAGE;
    case 8:
    case 'ASSOCIATED_CONTENT_TYPE_TRACK_CANVAS':
      return AssociatedContentType.ASSOCIATED_CONTENT_TYPE_TRACK_CANVAS;
    case 9:
    case 'ASSOCIATED_CONTENT_TYPE_ARTIST_MERCH':
      return AssociatedContentType.ASSOCIATED_CONTENT_TYPE_ARTIST_MERCH;
    case 10:
    case 'ASSOCIATED_CONTENT_TYPE_TRACK_MUSIC_VIDEO':
      return AssociatedContentType.ASSOCIATED_CONTENT_TYPE_TRACK_MUSIC_VIDEO;
    case 11:
    case 'ASSOCIATED_CONTENT_TYPE_ALBUM_OR_PODCAST_ARTWORK':
      return AssociatedContentType.ASSOCIATED_CONTENT_TYPE_ALBUM_OR_PODCAST_ARTWORK;
    default:
      throw new globalThis.Error('Unrecognized enum value ' + object + ' for enum AssociatedContentType');
  }
}

export function associatedContentTypeToJSON(object: AssociatedContentType): string {
  switch (object) {
    case AssociatedContentType.ASSOCIATED_CONTENT_TYPE_INVALID:
      return 'ASSOCIATED_CONTENT_TYPE_INVALID';
    case AssociatedContentType.ASSOCIATED_CONTENT_TYPE_ARTIST_BANNER_IMAGE:
      return 'ASSOCIATED_CONTENT_TYPE_ARTIST_BANNER_IMAGE';
    case AssociatedContentType.ASSOCIATED_CONTENT_TYPE_ARTIST_PROFILE_IMAGE:
      return 'ASSOCIATED_CONTENT_TYPE_ARTIST_PROFILE_IMAGE';
    case AssociatedContentType.ASSOCIATED_CONTENT_TYPE_ARTIST_GALLERY_IMAGE:
      return 'ASSOCIATED_CONTENT_TYPE_ARTIST_GALLERY_IMAGE';
    case AssociatedContentType.ASSOCIATED_CONTENT_TYPE_PLAYLIST_IMAGE:
      return 'ASSOCIATED_CONTENT_TYPE_PLAYLIST_IMAGE';
    case AssociatedContentType.ASSOCIATED_CONTENT_TYPE_PLAYLIST_TITLE:
      return 'ASSOCIATED_CONTENT_TYPE_PLAYLIST_TITLE';
    case AssociatedContentType.ASSOCIATED_CONTENT_TYPE_PLAYLIST_DESCRIPTION:
      return 'ASSOCIATED_CONTENT_TYPE_PLAYLIST_DESCRIPTION';
    case AssociatedContentType.ASSOCIATED_CONTENT_TYPE_USER_IMAGE:
      return 'ASSOCIATED_CONTENT_TYPE_USER_IMAGE';
    case AssociatedContentType.ASSOCIATED_CONTENT_TYPE_TRACK_CANVAS:
      return 'ASSOCIATED_CONTENT_TYPE_TRACK_CANVAS';
    case AssociatedContentType.ASSOCIATED_CONTENT_TYPE_ARTIST_MERCH:
      return 'ASSOCIATED_CONTENT_TYPE_ARTIST_MERCH';
    case AssociatedContentType.ASSOCIATED_CONTENT_TYPE_TRACK_MUSIC_VIDEO:
      return 'ASSOCIATED_CONTENT_TYPE_TRACK_MUSIC_VIDEO';
    case AssociatedContentType.ASSOCIATED_CONTENT_TYPE_ALBUM_OR_PODCAST_ARTWORK:
      return 'ASSOCIATED_CONTENT_TYPE_ALBUM_OR_PODCAST_ARTWORK';
    default:
      return 'UNKNOWN';
  }
}

export const ResolveEntityTypeRequest = {
  fromJSON(object: any): ResolveEntityTypeRequest {
    const message = { ...baseResolveEntityTypeRequest } as ResolveEntityTypeRequest;
    message.uri = [];
    if (object.uri !== undefined && object.uri !== null) {
      for (const e of object.uri) {
        message.uri.push(String(e));
      }
    }
    return message;
  },
  fromPartial(object: DeepPartial<ResolveEntityTypeRequest>): ResolveEntityTypeRequest {
    const message = { ...baseResolveEntityTypeRequest } as ResolveEntityTypeRequest;
    message.uri = [];
    if (object.uri !== undefined && object.uri !== null) {
      for (const e of object.uri) {
        message.uri.push(e);
      }
    }
    return message;
  },
  toJSON(message: ResolveEntityTypeRequest): unknown {
    const obj: any = {};
    if (message.uri) {
      obj.uri = message.uri.map(e => e);
    } else {
      obj.uri = [];
    }
    return obj;
  },
};

export const ResolveEntityTypeResponse = {
  fromJSON(object: any): ResolveEntityTypeResponse {
    const message = { ...baseResolveEntityTypeResponse } as ResolveEntityTypeResponse;
    message.resolvedEntityType = [];
    if (object.resolvedEntityType !== undefined && object.resolvedEntityType !== null) {
      for (const e of object.resolvedEntityType) {
        message.resolvedEntityType.push(ResolvedEntityType.fromJSON(e));
      }
    }
    return message;
  },
  fromPartial(object: DeepPartial<ResolveEntityTypeResponse>): ResolveEntityTypeResponse {
    const message = { ...baseResolveEntityTypeResponse } as ResolveEntityTypeResponse;
    message.resolvedEntityType = [];
    if (object.resolvedEntityType !== undefined && object.resolvedEntityType !== null) {
      for (const e of object.resolvedEntityType) {
        message.resolvedEntityType.push(ResolvedEntityType.fromPartial(e));
      }
    }
    return message;
  },
  toJSON(message: ResolveEntityTypeResponse): unknown {
    const obj: any = {};
    if (message.resolvedEntityType) {
      obj.resolvedEntityType = message.resolvedEntityType.map(e => (e ? ResolvedEntityType.toJSON(e) : undefined));
    } else {
      obj.resolvedEntityType = [];
    }
    return obj;
  },
};

export const ResolvedEntityType = {
  fromJSON(object: any): ResolvedEntityType {
    const message = { ...baseResolvedEntityType } as ResolvedEntityType;
    if (object.uri !== undefined && object.uri !== null) {
      message.uri = String(object.uri);
    } else {
      message.uri = '';
    }
    if (object.entityType !== undefined && object.entityType !== null) {
      message.entityType = entityTypeFromJSON(object.entityType);
    } else {
      message.entityType = 0;
    }
    if (object.entityExists !== undefined && object.entityExists !== null) {
      message.entityExists = Boolean(object.entityExists);
    } else {
      message.entityExists = false;
    }
    return message;
  },
  fromPartial(object: DeepPartial<ResolvedEntityType>): ResolvedEntityType {
    const message = { ...baseResolvedEntityType } as ResolvedEntityType;
    if (object.uri !== undefined && object.uri !== null) {
      message.uri = object.uri;
    } else {
      message.uri = '';
    }
    if (object.entityType !== undefined && object.entityType !== null) {
      message.entityType = object.entityType;
    } else {
      message.entityType = 0;
    }
    if (object.entityExists !== undefined && object.entityExists !== null) {
      message.entityExists = object.entityExists;
    } else {
      message.entityExists = false;
    }
    return message;
  },
  toJSON(message: ResolvedEntityType): unknown {
    const obj: any = {};
    message.uri !== undefined && (obj.uri = message.uri);
    message.entityType !== undefined && (obj.entityType = entityTypeToJSON(message.entityType));
    message.entityExists !== undefined && (obj.entityExists = message.entityExists);
    return obj;
  },
};

export const ResolveAssetTypeRequest = {
  fromJSON(object: any): ResolveAssetTypeRequest {
    const message = { ...baseResolveAssetTypeRequest } as ResolveAssetTypeRequest;
    if (object.uri !== undefined && object.uri !== null) {
      message.uri = String(object.uri);
    } else {
      message.uri = '';
    }
    if (object.associatedContentType !== undefined && object.associatedContentType !== null) {
      message.associatedContentType = associatedContentTypeFromJSON(object.associatedContentType);
    } else {
      message.associatedContentType = 0;
    }
    return message;
  },
  fromPartial(object: DeepPartial<ResolveAssetTypeRequest>): ResolveAssetTypeRequest {
    const message = { ...baseResolveAssetTypeRequest } as ResolveAssetTypeRequest;
    if (object.uri !== undefined && object.uri !== null) {
      message.uri = object.uri;
    } else {
      message.uri = '';
    }
    if (object.associatedContentType !== undefined && object.associatedContentType !== null) {
      message.associatedContentType = object.associatedContentType;
    } else {
      message.associatedContentType = 0;
    }
    return message;
  },
  toJSON(message: ResolveAssetTypeRequest): unknown {
    const obj: any = {};
    message.uri !== undefined && (obj.uri = message.uri);
    message.associatedContentType !== undefined &&
      (obj.associatedContentType = associatedContentTypeToJSON(message.associatedContentType));
    return obj;
  },
};

export const ResolveAssetTypeResponse = {
  fromJSON(object: any): ResolveAssetTypeResponse {
    const message = { ...baseResolveAssetTypeResponse } as ResolveAssetTypeResponse;
    if (object.assetExists !== undefined && object.assetExists !== null) {
      message.assetExists = Boolean(object.assetExists);
    } else {
      message.assetExists = false;
    }
    return message;
  },
  fromPartial(object: DeepPartial<ResolveAssetTypeResponse>): ResolveAssetTypeResponse {
    const message = { ...baseResolveAssetTypeResponse } as ResolveAssetTypeResponse;
    if (object.assetExists !== undefined && object.assetExists !== null) {
      message.assetExists = object.assetExists;
    } else {
      message.assetExists = false;
    }
    return message;
  },
  toJSON(message: ResolveAssetTypeResponse): unknown {
    const obj: any = {};
    message.assetExists !== undefined && (obj.assetExists = message.assetExists);
    return obj;
  },
};

export const AssociatedContentRequest = {
  fromJSON(object: any): AssociatedContentRequest {
    const message = { ...baseAssociatedContentRequest } as AssociatedContentRequest;
    if (object.uri !== undefined && object.uri !== null) {
      message.uri = String(object.uri);
    } else {
      message.uri = '';
    }
    if (object.associatedContentType !== undefined && object.associatedContentType !== null) {
      message.associatedContentType = associatedContentTypeFromJSON(object.associatedContentType);
    } else {
      message.associatedContentType = 0;
    }
    return message;
  },
  fromPartial(object: DeepPartial<AssociatedContentRequest>): AssociatedContentRequest {
    const message = { ...baseAssociatedContentRequest } as AssociatedContentRequest;
    if (object.uri !== undefined && object.uri !== null) {
      message.uri = object.uri;
    } else {
      message.uri = '';
    }
    if (object.associatedContentType !== undefined && object.associatedContentType !== null) {
      message.associatedContentType = object.associatedContentType;
    } else {
      message.associatedContentType = 0;
    }
    return message;
  },
  toJSON(message: AssociatedContentRequest): unknown {
    const obj: any = {};
    message.uri !== undefined && (obj.uri = message.uri);
    message.associatedContentType !== undefined &&
      (obj.associatedContentType = associatedContentTypeToJSON(message.associatedContentType));
    return obj;
  },
};

export const MultipleAssociatedContentRequest = {
  fromJSON(object: any): MultipleAssociatedContentRequest {
    const message = { ...baseMultipleAssociatedContentRequest } as MultipleAssociatedContentRequest;
    message.uris = [];
    if (object.uris !== undefined && object.uris !== null) {
      for (const e of object.uris) {
        message.uris.push(String(e));
      }
    }
    if (object.associatedContentType !== undefined && object.associatedContentType !== null) {
      message.associatedContentType = associatedContentTypeFromJSON(object.associatedContentType);
    } else {
      message.associatedContentType = 0;
    }
    return message;
  },
  fromPartial(object: DeepPartial<MultipleAssociatedContentRequest>): MultipleAssociatedContentRequest {
    const message = { ...baseMultipleAssociatedContentRequest } as MultipleAssociatedContentRequest;
    message.uris = [];
    if (object.uris !== undefined && object.uris !== null) {
      for (const e of object.uris) {
        message.uris.push(e);
      }
    }
    if (object.associatedContentType !== undefined && object.associatedContentType !== null) {
      message.associatedContentType = object.associatedContentType;
    } else {
      message.associatedContentType = 0;
    }
    return message;
  },
  toJSON(message: MultipleAssociatedContentRequest): unknown {
    const obj: any = {};
    if (message.uris) {
      obj.uris = message.uris.map(e => e);
    } else {
      obj.uris = [];
    }
    message.associatedContentType !== undefined &&
      (obj.associatedContentType = associatedContentTypeToJSON(message.associatedContentType));
    return obj;
  },
};

export const MultipleAssociatedContentResponse = {
  fromJSON(object: any): MultipleAssociatedContentResponse {
    const message = { ...baseMultipleAssociatedContentResponse } as MultipleAssociatedContentResponse;
    message.associatedContent = [];
    if (object.associatedContent !== undefined && object.associatedContent !== null) {
      for (const e of object.associatedContent) {
        message.associatedContent.push(AssociatedContentResponse.fromJSON(e));
      }
    }
    return message;
  },
  fromPartial(object: DeepPartial<MultipleAssociatedContentResponse>): MultipleAssociatedContentResponse {
    const message = { ...baseMultipleAssociatedContentResponse } as MultipleAssociatedContentResponse;
    message.associatedContent = [];
    if (object.associatedContent !== undefined && object.associatedContent !== null) {
      for (const e of object.associatedContent) {
        message.associatedContent.push(AssociatedContentResponse.fromPartial(e));
      }
    }
    return message;
  },
  toJSON(message: MultipleAssociatedContentResponse): unknown {
    const obj: any = {};
    if (message.associatedContent) {
      obj.associatedContent = message.associatedContent.map(e => (e ? AssociatedContentResponse.toJSON(e) : undefined));
    } else {
      obj.associatedContent = [];
    }
    return obj;
  },
};

export const AssociatedContentResponse = {
  fromJSON(object: any): AssociatedContentResponse {
    const message = { ...baseAssociatedContentResponse } as AssociatedContentResponse;
    message.elements = [];
    if (object.parentEntityExists !== undefined && object.parentEntityExists !== null) {
      message.parentEntityExists = Boolean(object.parentEntityExists);
    } else {
      message.parentEntityExists = false;
    }
    if (object.elements !== undefined && object.elements !== null) {
      for (const e of object.elements) {
        message.elements.push(AssociatedContent.fromJSON(e));
      }
    }
    if (object.entityType !== undefined && object.entityType !== null) {
      message.entityType = entityTypeFromJSON(object.entityType);
    } else {
      message.entityType = 0;
    }
    if (object.parentUri !== undefined && object.parentUri !== null) {
      message.parentUri = String(object.parentUri);
    } else {
      message.parentUri = '';
    }
    return message;
  },
  fromPartial(object: DeepPartial<AssociatedContentResponse>): AssociatedContentResponse {
    const message = { ...baseAssociatedContentResponse } as AssociatedContentResponse;
    message.elements = [];
    if (object.parentEntityExists !== undefined && object.parentEntityExists !== null) {
      message.parentEntityExists = object.parentEntityExists;
    } else {
      message.parentEntityExists = false;
    }
    if (object.elements !== undefined && object.elements !== null) {
      for (const e of object.elements) {
        message.elements.push(AssociatedContent.fromPartial(e));
      }
    }
    if (object.entityType !== undefined && object.entityType !== null) {
      message.entityType = object.entityType;
    } else {
      message.entityType = 0;
    }
    if (object.parentUri !== undefined && object.parentUri !== null) {
      message.parentUri = object.parentUri;
    } else {
      message.parentUri = '';
    }
    return message;
  },
  toJSON(message: AssociatedContentResponse): unknown {
    const obj: any = {};
    message.parentEntityExists !== undefined && (obj.parentEntityExists = message.parentEntityExists);
    if (message.elements) {
      obj.elements = message.elements.map(e => (e ? AssociatedContent.toJSON(e) : undefined));
    } else {
      obj.elements = [];
    }
    message.entityType !== undefined && (obj.entityType = entityTypeToJSON(message.entityType));
    message.parentUri !== undefined && (obj.parentUri = message.parentUri);
    return obj;
  },
};

export const AssociatedContent = {
  fromJSON(object: any): AssociatedContent {
    const message = { ...baseAssociatedContent } as AssociatedContent;
    if (object.id !== undefined && object.id !== null) {
      message.id = String(object.id);
    } else {
      message.id = '';
    }
    if (object.value !== undefined && object.value !== null) {
      message.value = String(object.value);
    } else {
      message.value = '';
    }
    return message;
  },
  fromPartial(object: DeepPartial<AssociatedContent>): AssociatedContent {
    const message = { ...baseAssociatedContent } as AssociatedContent;
    if (object.id !== undefined && object.id !== null) {
      message.id = object.id;
    } else {
      message.id = '';
    }
    if (object.value !== undefined && object.value !== null) {
      message.value = object.value;
    } else {
      message.value = '';
    }
    return message;
  },
  toJSON(message: AssociatedContent): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.value !== undefined && (obj.value = message.value);
    return obj;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | undefined;
type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;
